<template>
  <div class="step-finish">
    <h2 class="title">Finalizar consulta recorrente</h2>
    <p class="description">Antes de finalizar a consulta recorrente é importante verificar os custos de acordo com a periodicidade selecionada.</p>

    <p><b>Valor total estimado (R$): {{ (total === 0 && recurrent ? recurrent.estimated_value : total) | currency }}</b></p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import currency from '@/support/filters/currency';

export default {
  name: 'StepFinish',

  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  data() {
    return {
    };
  },

  filters: {
    currency,
  },

  computed: {
    ...mapState('template', {
      template: 'template',
    }),
    ...mapState('recurrent', {
      total: 'total',
    }),
    ...mapState('recurrent', {
      recurrent: 'recurrent',
    }),
  },
};
</script>

<style lang="scss" scoped>
.step-finish {
  > .title {
    @apply text-3xl;
    @apply text-center;
  }

  > .description {
    @apply pb-4;
    @apply text-sm;
    @apply text-center;
  }
}
</style>
